import { Box, Typography } from '@mui/material'
import useStyles from './_styles'

export default function PlannedExpertiseWorkflowQuestionHeader({
  question,
  currentStep,
  totalSteps,
}: {
  question: any;
  currentStep: number;
  totalSteps: number;
}) {
  const classes = useStyles()

    if (!question) {
      return null
    }

  return (
    <Box className={classes.questionWrapper}>
      <Box className={classes.questionHeader}>
        <Typography className={classes.questionSectionLabel}>{question.sectionLabel}</Typography>
        <Typography className={classes.questionTitle}>{question.title}</Typography>
        {question.hint && <Typography className={classes.questionHint}>{question.hint}</Typography>}
      </Box>
    </Box>
  )
}
